import { useReducer } from 'react';
import { useEventCallback } from './useEventCallback';
import { useLayoutEffect } from './useLayoutEffect';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';
const initialState = {
  render: false,
  animating: false
};
function reducer(state, action) {
  switch (action) {
    case 'show':
      return {
        ...state,
        render: true
      };
    case 'hide':
      return {
        ...state,
        render: false
      };
    case 'start':
      return {
        ...state,
        animating: true
      };
    case 'stop':
      return {
        ...state,
        animating: false
      };
    default:
      throw new Error();
  }
}
export function useAnimation(props = {}) {
  const {
    visible = false
  } = props;
  const [{
    render,
    animating
  }, dispatch] = useReducer(reducer, initialState);
  const prefersReducedMotion = usePrefersReducedMotion();
  useLayoutEffect(() => {
    if (visible) dispatch('show');
    if (!visible && prefersReducedMotion) dispatch('hide');
  }, [prefersReducedMotion, visible]);
  const onAnimationStart = useEventCallback(() => {
    dispatch('start');
  });
  const onAnimationEnd = useEventCallback(() => {
    if (!visible) dispatch('hide');
    dispatch('stop');
  });
  return {
    render,
    animating,
    onAnimationStart,
    onAnimationEnd
  };
}